// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.planningCard-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.planningCard-container h2 {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

.planningCard-cardsWrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.planningCard-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  transition: transform 0.2s;
}

.planningCard-card:hover {
  transform: translateY(-5px);
}

.planningCard-air {
  border-left: 4px solid #3498db;
}

.planningCard-sea {
  border-left: 4px solid #2ecc71;
}

.planningCard-land {
  border-left: 4px solid #f1c40f;
}

.planningCard-card h3 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

.planningCard-card p {
  font-size: 14px;
  color: #555;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
}

.planningCard-card p strong {
  font-weight: 600;
  color: #333;
  width: 150px;
}

@media (max-width: 768px) {
  .planningCard-container {
    padding: 15px;
  }

  .planningCard-container h2 {
    font-size: 24px;
  }

  .planningCard-card h3 {
    font-size: 18px;
  }

  .planningCard-card p {
    font-size: 13px;
  }

  .planningCard-card p strong {
    width: 100%;
    margin-bottom: 5px;
  }
}

@media (max-width: 480px) {
  .planningCard-container h2 {
    font-size: 20px;
  }

  .planningCard-card {
    padding: 15px;
  }

  .planningCard-card h3 {
    font-size: 16px;
  }

  .planningCard-card p {
    font-size: 12px;
  }
}
.planning_crd_viewButton {
  background-color: #3498db;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  font-size: 16px;
}

/* ********** */

.planning_crd_sentToProjectButton {
  margin-left: 5px;
  padding: 10px 20px;
  background: #3394d5;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}
.project-executive-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.project-executive-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 450px;
  background: #ffffff;
  padding: 30px 20px;
  border-radius: 14px;
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.2);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.project-executive-close-button {
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  color: #333;
  transition: color 0.3s ease;
}

.project-executive-close-button:hover {
  color: #ff4d4f;
}

.project-executive-container h2 {
  margin-bottom: 20px;
  font-size: 24px;
  color: #222;
  text-align: center;
}

.project-executive-container form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.project-executive-select {
  width: 100%;
  padding: 12px 16px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #fafafa;
}

.project-executive-submit-button {
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, #6c63ff, #5a54d6);
  color: white;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.project-executive-submit-button:hover {
  background: linear-gradient(135deg, #5a54d6, #4c43b8);
}
.planning_multi_button {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

/* Responsive Adjustments */
@media (max-width: 480px) {
  .project-executive-container {
    width: 90%;
    padding: 20px 15px;
  }

  .project-executive-container h2 {
    font-size: 20px;
  }

  .project-executive-select,
  .project-executive-submit-button {
    font-size: 14px;
    padding: 10px 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Planning/planning.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,eAAe;;AAEf;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,0CAA0C;AAC5C;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,qDAAqD;AACvD;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".planningCard-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.planningCard-container h2 {\n  font-size: 28px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.planningCard-cardsWrapper {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n.planningCard-card {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  transition: transform 0.2s;\n}\n\n.planningCard-card:hover {\n  transform: translateY(-5px);\n}\n\n.planningCard-air {\n  border-left: 4px solid #3498db;\n}\n\n.planningCard-sea {\n  border-left: 4px solid #2ecc71;\n}\n\n.planningCard-land {\n  border-left: 4px solid #f1c40f;\n}\n\n.planningCard-card h3 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 15px;\n}\n\n.planningCard-card p {\n  font-size: 14px;\n  color: #555;\n  margin-bottom: 10px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.planningCard-card p strong {\n  font-weight: 600;\n  color: #333;\n  width: 150px;\n}\n\n@media (max-width: 768px) {\n  .planningCard-container {\n    padding: 15px;\n  }\n\n  .planningCard-container h2 {\n    font-size: 24px;\n  }\n\n  .planningCard-card h3 {\n    font-size: 18px;\n  }\n\n  .planningCard-card p {\n    font-size: 13px;\n  }\n\n  .planningCard-card p strong {\n    width: 100%;\n    margin-bottom: 5px;\n  }\n}\n\n@media (max-width: 480px) {\n  .planningCard-container h2 {\n    font-size: 20px;\n  }\n\n  .planningCard-card {\n    padding: 15px;\n  }\n\n  .planningCard-card h3 {\n    font-size: 16px;\n  }\n\n  .planningCard-card p {\n    font-size: 12px;\n  }\n}\n.planning_crd_viewButton {\n  background-color: #3498db;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  text-align: center;\n  text-decoration: none;\n  font-size: 16px;\n}\n\n/* ********** */\n\n.planning_crd_sentToProjectButton {\n  margin-left: 5px;\n  padding: 10px 20px;\n  background: #3394d5;\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 600;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n}\n.project-executive-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n}\n\n.project-executive-container {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90%;\n  max-width: 450px;\n  background: #ffffff;\n  padding: 30px 20px;\n  border-radius: 14px;\n  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.2);\n  z-index: 1001;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.project-executive-close-button {\n  position: absolute;\n  top: 12px;\n  right: 16px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  font-weight: bold;\n  cursor: pointer;\n  color: #333;\n  transition: color 0.3s ease;\n}\n\n.project-executive-close-button:hover {\n  color: #ff4d4f;\n}\n\n.project-executive-container h2 {\n  margin-bottom: 20px;\n  font-size: 24px;\n  color: #222;\n  text-align: center;\n}\n\n.project-executive-container form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.project-executive-select {\n  width: 100%;\n  padding: 12px 16px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  background: #fafafa;\n}\n\n.project-executive-submit-button {\n  width: 100%;\n  padding: 12px;\n  background: linear-gradient(135deg, #6c63ff, #5a54d6);\n  color: white;\n  font-size: 16px;\n  font-weight: 600;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.project-executive-submit-button:hover {\n  background: linear-gradient(135deg, #5a54d6, #4c43b8);\n}\n.planning_multi_button {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 480px) {\n  .project-executive-container {\n    width: 90%;\n    padding: 20px 15px;\n  }\n\n  .project-executive-container h2 {\n    font-size: 20px;\n  }\n\n  .project-executive-select,\n  .project-executive-submit-button {\n    font-size: 14px;\n    padding: 10px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
